export default __webpack_public_path__ + "static/media/p5.290c937c.jpg";